import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformActivityCard } from "./-components/platform-activity-card";

export const Route = createFileRoute("/_authenticated/platform_/activity")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-activity"),
  component: PlatformActivity,
});

/** What the platform team did: entries into organizations, exits and team changes. */
function PlatformActivity() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Platform activity"
        meta="Who entered which organization and why, who left, and every change to the team."
      />
      <PlatformActivityCard />
    </div>
  );
}
